// extracted by mini-css-extract-plugin
module.exports = {"loader-strip-container":"loader-strip_loader-strip-container__vWjMX","loader-strip":"loader-strip_loader-strip__Zl_Is"};